import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppSettingsIcon = (props: Props) => {
  const { className, ...rest } = props;
  return <Cog6ToothIcon {...rest} className={className} />;
};
export default withIconSize(AppSettingsIcon);
